import React from 'react';
import { htmlWidget } from '../../Constants'

const IconTextTile = (props)=> {
const {icon, iconAltText, text} = props.iconText
return(
    <div className="icon-text-tile-container">
        <div className="icon-text-tile">
             <img src={icon ? icon.path : ""} alt={iconAltText ? iconAltText :""}/>
             <div className={"bundle-card-icon-text "+htmlWidget} dangerouslySetInnerHTML={{ __html: text }} />
        </div>
    </div>
);
}

export default IconTextTile;
